import { createAppAsyncThunk } from '@/redux/create-app-thunk';
import { tryCatch } from '@/redux/thunks/shared/try-catch';

export const removeIncompatibleProductsFromCheckout = createAppAsyncThunk(
  'checkout/removeIncompatibleProducts',
  async (_, { getState, rejectWithValue, extra: { checkoutService } }) => {
    const { data, error } = await tryCatch(
      checkoutService.removeIncompatibleProducts({ storeId: getState().root.storeConf.storeId })
    );

    if (error) {
      return rejectWithValue(error);
    }
    return data;
  }
);
